import React, { useEffect, useState } from "react";
import ArticlesList from "../components/ArticlesList";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import Pagination from "../components/Pagination";
import "./Home.scss";

const Homepage = () => {
    const [articles, setArticles] = useState([]);
    const [totalPages, setTotalPages] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const { pageNumber } = useParams();
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        if (pageNumber) {
            setCurrentPage(parseInt(pageNumber));
        } else {
            setCurrentPage(1);
        }

        const fetchArticles = async () => {
            try {
                setLoading(true);
                let pageNumberUrl;
                if (pageNumber === undefined) {
                    pageNumberUrl = 1;
                } else {
                    pageNumberUrl = pageNumber;
                }
                const triggerApi = await axios.get(
                    "https://momentumpress.onrender.com/"
                );
                console.log(triggerApi.data);
                const response = await axios.get(
                    `${process.env.REACT_APP_BE_SERVER}/articles?page=${pageNumberUrl}`
                );
                setArticles(response.data.articles);
                setTotalPages(Math.ceil(response.data.totalCount / 9));
                setLoading(false);
                window.scrollTo({
                    top: 0,
                    behavior: "smooth",
                });
            } catch (error) {
                console.error("Failed to fetch articles: ", error);
            }
        };

        fetchArticles();
    }, [pageNumber]);

    const handlePrevPage = () => {
        if (currentPage > 1) {
            navigate(`/page/${currentPage - 1}`);
        }
    };

    const handleNextPage = () => {
        if (currentPage < totalPages) {
            navigate(`/page/${currentPage + 1}`);
        }
    };

    return (
        <div className="home layout">
            <h1>Welcome to the Homepage</h1>
            {loading ? (
                "Loading..."
            ) : (
                <>
                    {articles.length > 0 && (
                        <ArticlesList articles={articles} />
                    )}
                    <Pagination
                        handleNextPage={handleNextPage}
                        handlePrevPage={handlePrevPage}
                        currentPage={currentPage}
                        totalPages={totalPages}
                    />
                </>
            )}
        </div>
    );
};

export default Homepage;
